module.exports = __webpack_public_path__ + "static/img/Rijswijk.664d95d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rijswijk.jpg
// module id = bAYr
// module chunks = 1